import { render, staticRenderFns } from "./HelpContent.vue?vue&type=template&id=37d4c6e4&scoped=true&"
import script from "./HelpContent.vue?vue&type=script&lang=js&"
export * from "./HelpContent.vue?vue&type=script&lang=js&"
import style0 from "./HelpContent.vue?vue&type=style&index=0&id=37d4c6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4c6e4",
  null
  
)

export default component.exports